import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHammer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHammer"><Path d="M5.5 15.5L1.5 11.5L10.5 2.5H14.5L16.5 4.5L5.5 15.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M9.5 12.5L18 21L21 18L12.5 9.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHammer;
